// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container___E3f2","rotation":"style_rotation__o_R2D"};